<div class="flex-fill d-flex flex-column">
    <div class="flex-fill content-block dx-card responsive-paddings">
        <div class="d-flex flex-fill">
            <dx-data-grid
                #overviewGrid
                keyExpr="id"
                [dataSource]="zips"
                [showBorders]="true"
                (onToolbarPreparing)="onToolbarPreparing($event)"
                (onRowDblClick)="rowDoubleClick($event)"
            >
                <dxi-data-grid-column dataField="zoneNumber" width="150"></dxi-data-grid-column>
                <dxi-data-grid-column dataField="zipCode" width="150"></dxi-data-grid-column>
                <dxi-data-grid-column dataField="primaryCity" width="150"></dxi-data-grid-column>
                <dxi-data-grid-column dataField="county" width="150"></dxi-data-grid-column>
                <dxi-data-grid-column dataField="type" width="150"></dxi-data-grid-column>
                <dxi-data-grid-column dataField="color" width="150"></dxi-data-grid-column>
                <dxi-data-grid-column dataField="territory" width="150"></dxi-data-grid-column>
                <dxi-data-grid-column dataField="isActive" width="100"></dxi-data-grid-column>
                <dxi-data-grid-column></dxi-data-grid-column>

                <dxo-data-grid-selection mode="multiple"></dxo-data-grid-selection>
                <dxo-data-grid-search-panel [visible]="true"></dxo-data-grid-search-panel>
                <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
                <dxo-data-grid-export [enabled]="true" [allowExportSelectedData]="true"></dxo-data-grid-export>
                <dxo-data-grid-state-storing [enabled]="true" type="localStorage" storageKey="zone-zip-overview-grid"></dxo-data-grid-state-storing>
                <div *dxTemplate="let data of 'toolbarButtons'">
                    <button
                        class="btn btn-primary me-1 mb-2"
                        (click)="open(overviewGrid.instance.getSelectedRowsData()[0])"
                        [disabled]="overviewGrid.instance.getSelectedRowsData().length !== 1"
                    >
                        Edit
                    </button>
                    <button class="btn btn-warning ms-2 mb-2" (click)="toggleShowAll()">
                        {{ showAll ? 'Hide Inactive' : 'Show All' }}
                    </button>
                </div>
            </dx-data-grid>
        </div>
        <div class="autocomplete-container" id="autocomplete-container"></div>
    </div>
</div>
